import constants from '@core/utils/constants';
import { bus } from '@core/events/eventSystem';
import { getStore } from '@core/store';

let initiated = false;
const routeHistory = [];
let fullHistory = [];
let newRouteIndex = 0;
let lastRoute = null;
let pushingRoute = false;

bus.on(constants.EVENTS.APP.READY, () => {
  if (initiated) return;
  initiated = true;

  // mettre à jour le tableau de routes très rapidement
  setInterval(() => {
    if (pushingRoute) return;
    const current = getUrl();
    if (current !== lastRoute) {
      routeHistory.push(current);
      fullHistory = [
        ...routeHistory,
        ...fullHistory.slice(routeHistory.length)
      ];
      lastRoute = current;
    }
    window.routeHistory = routeHistory;
    window.lastRoute = lastRoute;
    window.newRouteIndex = newRouteIndex;
    window.fullHistory = fullHistory;
  }, 50);

  window.addEventListener('popstate', (event) => {
    pushingRoute = true;
    console.log('🚀 ~ popstate event:', event);
    const current = getUrl();
    console.log('🚀 ~ current:', current);
    console.log('🚀 ~ lastRoute:', lastRoute);
    console.log('🚀 ~ routeHistory:', routeHistory);
    newRouteIndex = routeHistory.lastIndexOf(current);
    const nextRouteIndex = routeHistory.lastIndexOf(lastRoute) + 1;

    if (current == lastRoute) {
      dispatchBack();
    } else if (fullHistory[nextRouteIndex] == current) {
      window.$router.push(current);
      pushingRoute = false;
    } else if (newRouteIndex >= 0 && newRouteIndex == routeHistory.length - 2) {
      backRoute();
    } else {
      window.$router.push(current);
    }
  });

  window.addEventListener('message', (event) => {
    console.log('🚀 ~ handleMessage ~ event:', event);
    if (event.data?.type !== 'APP_BACK_DETECTED') return;
    const current = getUrl();
    newRouteIndex = routeHistory.lastIndexOf(current);
    dispatchBack();
  });

  document.addEventListener('click', (ev) => {
    const isLink = !!ev.target.closest('a');
    if (isLink) return;
    window.history.pushState({ date: Date.now() }, null, '');
    console.log('pushed from click 500');
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      dispatchDialogClose();
    }
  });

  window.closeAllDialogs = closeAllDialogs;
});

function getUrl() {
  return (
    window.location.pathname + window.location.search + window.location.hash
  );
}

function backRoute() {
  window.programaticBackCalled = true;
  window.$router.back();
  routeHistory.splice(newRouteIndex);
  lastRoute = routeHistory[routeHistory.length - 1] || null;
  pushingRoute = false;
}

function dispatchBack() {
  const store = getStore('dialog');
  const dialogOnTop =
    store.state.openedDialogStack[store.state.openedDialogStack.length - 1];

  if (!dialogOnTop) {
    backRoute();
    return;
  }

  bus.emit(constants.EVENTS.DIALOG.BACK_ACTION_CLOSE_REQUIRED, {
    index: dialogOnTop.index,
    id: dialogOnTop.id
  });
  if (pushingRoute) {
    pushingRoute = false;
    // setTimeout(() => {
    // window.history.pushState({ date: Date.now() }, null, '');
    // }, 500);
  }
}

function dispatchDialogClose() {
  const store = getStore('dialog');
  const dialogOnTop =
    store.state.openedDialogStack[store.state.openedDialogStack.length - 1];
  if (!dialogOnTop) return;

  bus.emit(constants.EVENTS.DIALOG.BACK_ACTION_CLOSE_REQUIRED, {
    index: dialogOnTop.index,
    id: dialogOnTop.id
  });
}

function closeAllDialogs() {
  const store = getStore('dialog');
  const stack = store.state.openedDialogStack;

  if (!stack || stack.length === 0) return;

  // On crée une copie du tableau pour éviter les problèmes de mutation pendant la boucle
  const dialogsToClose = [...stack];

  dialogsToClose.forEach((dialog) => {
    bus.emit(constants.EVENTS.DIALOG.BACK_ACTION_CLOSE_REQUIRED, {
      index: dialog.index,
      id: dialog.id
    });
  });
}
